import Card from "@/components/Card";
import { AnswerCategory } from "@/schema/console/evaluation-reports/AnswerCategory";
import CategoryHeader from "@/src/console/(auth)/_components/AssessmentResultDialog/CategoryHeader";
import QuestionList from "@/src/console/(auth)/_components/AssessmentResultDialog/QuestionList/QuestionList";
import { useState } from "react";

interface Props {
  category: AnswerCategory;
}

function CategoryDetailPanel({ category }: Props) {
  const [selectedSubCategoryIndex, setSelectedSubCategoryIndex] = useState(0);

  return (
    <div className=" flex flex-col space-y-5">
      <CategoryHeader
        category={category}
        onSubCategoryChange={(subCategoryId: number) => {
          const index = category.answer_sub_categories.findIndex(
            (subCategory) => subCategory.id === subCategoryId,
          );

          setSelectedSubCategoryIndex(index);
        }}
      />
      <Card>
        <QuestionList
          answerSubCategory={
            category.answer_sub_categories[selectedSubCategoryIndex]
          }
        />
      </Card>
    </div>
  );
}

export default CategoryDetailPanel;
